import { useEffect, useState } from "react";
import {
  getKeycloak,
  hasInterviewAuthHint,
  hasOAuthCallbackInUrl,
  initInterviewAuth,
} from "../auth/keycloak";
import InterviewAuthRequiredModal from "../modules/interview/auth-required-modal";

type Props = {
  children: React.ReactNode;
};

type GateState = "loading" | "authenticated" | "unauthenticated" | "error";

export function InterviewGate({ children }: Props) {
  const [state, setState] = useState<GateState>(() =>
    hasInterviewAuthHint() || hasOAuthCallbackInUrl() ? "loading" : "unauthenticated"
  );

  useEffect(() => {
    if (state !== "loading") return;

    let cancelled = false;

    (async () => {
      try {
        await initInterviewAuth();
        if (cancelled) return;
        setState(getKeycloak().authenticated ? "authenticated" : "unauthenticated");
      } catch (error) {
        console.error("Interview auth failed", error);
        if (!cancelled) {
          setState("error");
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [state]);

  if (state === "loading") {
    return <div>Проверяем авторизацию…</div>;
  }

  if (state === "error") {
    return <div>Не удалось выполнить вход.</div>;
  }

  if (state === "unauthenticated") {
    return <InterviewAuthRequiredModal />;
  }

  return <>{children}</>;
}
